module.exports = __webpack_public_path__ + "static/media/_serviceMainImageDesktop@2x.4071d250.png";